import { Role, rolesManipulator } from 'auth';
import classNames from 'classnames';
import { useBuildNotificationFromJson } from '@/modules/common/hooks/useBuildNotificationFromJson.tsx';
import { useRegisterTypeStrings } from '@/modules/common/hooks/useRegisterTypeStrings.tsx';
import { BaseModalProps, ModalContentWrapper } from 'ui';
import { useIsMobile } from 'ui/hooks';
import { fixNameEnum } from 'ui/utils';
import { EventLogType } from 'api';
import 'react-quill/dist/quill.snow.css';

export interface IssuerAddAnnouncementModalProps extends BaseModalProps {
  created_at: string;
  type: EventLogType;
  data: object;
}

export const IssuerReadNotificationModal = ({
  open,
  type,
  data,
  created_at,
  onClose,
}: IssuerAddAnnouncementModalProps) => {
  const { isMobile } = useIsMobile();
  const getRegisterTypeString = useRegisterTypeStrings();
  const text = useBuildNotificationFromJson(
    type,
    data,
    false,
    rolesManipulator.current_user_role === Role.SR_ISSUER ||
      rolesManipulator.current_user_role === Role.SR_ISSUER_ADMIN,
  );

  const isActive = (data as any)?.['is_active'] ?? false;
  const isHistorical = (data as any)?.['is_historical'] ?? false;
  const isFuture = (data as any)?.['is_future'] ?? false;

  return (
    <ModalContentWrapper
      open={open}
      title={
        (isActive ? 'Active' : isHistorical ? 'Historical' : isFuture ? 'Future' : '') +
        ' ' +
        fixNameEnum(type)
          .replace('Nav', getRegisterTypeString('nav', { capitalize: true }))
          .replace('Dividend', getRegisterTypeString('Dividend', { capitalize: true }))
          .replace('Finalized', 'Finalised')
      }
      onClose={onClose}
    >
      <div
        className={classNames('text-[12px] leading-[20px] text-gray-500 relative', {
          'bottom-3': isMobile,
          'bottom-5': !isMobile,
        })}
      >
        {created_at}
      </div>
      <hr className={`${isMobile ? 'w-[106.5%] relative right-3' : 'w-[109%] relative right-6'}`} />
      <div className="pt-5">{text}</div>
    </ModalContentWrapper>
  );
};
